import styled from 'styled-components';

// Wrapper inline (substitui o antigo modal). Empilha SearchBox + ChipsRow
// pra economizar espaco horizontal e funcionar bem em viewports estreitos.
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-radius: 6px;
  background: ${(props) => props.theme.colors.card};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  transition: border-color 150ms ease, box-shadow 150ms ease;

  :focus-within {
    border-color: ${(props) => props.theme.colors.lightblue};
    box-shadow: none;
  }
`;

export const SearchIcon = styled.img`
  width: 16px;
  height: 16px;
  opacity: 0.6;
  flex-shrink: 0;
`;

export const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  color: ${(props) => props.theme.colors.darkerblue};

  ::placeholder {
    color: ${(props) => props.theme.colors.label};
    opacity: 0.7;
  }
`;

export const ClearButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 0, 0, 0.08)'
      : 'rgba(255, 255, 255, 0.10)'};
  color: ${(props) => props.theme.colors.label};
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  font-family: inherit;
  transition: background 120ms ease, color 120ms ease;

  :hover {
    background: ${(props) => props.theme.colors.red};
    color: ${(props) => props.theme.colors.white};
  }
`;

export const ChipsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

export const Chip = styled.button`
  padding: 4px 12px;
  height: 26px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: all 120ms ease;
  border: 1px solid
    ${(props) =>
      props['aria-pressed'] === 'true'
        ? props.theme.colors.lightblue
        : props.theme.colors.disabled};
  background: ${(props) =>
    props['aria-pressed'] === 'true'
      ? props.theme.colors.lightblue
      : 'transparent'};
  color: ${(props) =>
    props['aria-pressed'] === 'true'
      ? props.theme.colors.white
      : props.theme.colors.label};

  :hover {
    border-color: ${(props) => props.theme.colors.lightblue};
    color: ${(props) =>
      props['aria-pressed'] === 'true'
        ? props.theme.colors.white
        : props.theme.colors.lightblue};
  }
`;
